module.exports = __webpack_public_path__ + "img/secKill_bg1.677c3db7.png";